

import {Request} from '@/api/request';
import {
  defineComponent,
  ref,
  reactive,
  inject,
  provide,
  onMounted,
  watch,
} from "vue";
import {getOrderCarMountings, getOrderCarProject, getPurchaseInfo, postAddOrderOffer} from "@/api/http";
import {dateformat} from "@/api/date" ;
import {column} from "@/assets/types/common";
import editList from "@/components/editlist/editlist.vue";
import editLista from "@/components/editlista/editlista.vue";
import {useRoute, useRouter} from 'vue-router'
import {validateInput, validateClass} from "@/assets/js/formRules";

type project = {
  id: number;
  project_type_pid: number;
  name: string;
};
type dialogSelect = {
  project_type_pid?: number;
  search?: string;
};
type order = {
  basicset_id: number;
  id: number;
  user_id: number;
  coupon_text: string;
  pay_type: number;
  payment: number;
  order: any;
  order_car: any;
  order_message: any;
  offer: any;
  last_order_id: string;
  next_order_id: string
};

const partsColumn: Array<column> = [
  {
    prop: "name",
    label: "项目名称",
    width: 84,
  },
  {
    prop: "mountings_name",
    label: "配件名称",
    width: 84,
  },

  {
    prop: "specification",
    label: "规格",
    width: 84,
  },
  {
    prop: "mountings_type_name",
    label: "配件分类",
    width: 84,
  },
  {
    prop: "mountings_brand_name",
    label: "品牌",
    width: 84,
  },
  {
    prop: "mountings_unit_name",
    label: "单位",
    width: 84,
  },
  {
    prop: "price",
    label: "价格",
    width: 84,
  },
  {
    prop: "stock",
    label: "库存",
    width: 84,
  },
];
const return_cash_plan = {
  return_cash_plan: [
    {
      required: true,
      validator: (rule: any, value: string, callback: Function) => {
        if (value) {
          callback();
        } else {
          callback(new Error("请选择返现方案"));
        }
      },
      trigger: "blur",
    },
  ],
};
const partsRules = {
  name: [
    {
      required: true,
      validator: (rule: any, value: string, callback: Function) => {
        validateInput("请输入配件名称", value, callback);
      },
      trigger: "change",
    },
  ],
  price: [
    {
      required: true,
      validator: (rule: any, value: string, callback: Function) => {
        validateInput("请输入销售价", value, callback);
      },
      trigger: "change",
    },
  ],
  specification: [
    {
      required: true,
      validator: (rule: any, value: string, callback: Function) => {
        validateInput("请输入规格", value, callback);
      },
      trigger: "change",
    },
  ],
  encoding: [
    {
      required: true,
      validator: (rule: any, value: string, callback: Function) => {
        validateInput("请输入编码", value, callback);
      },
      trigger: "change",
    },
  ],
  unit_id: [
    {
      required: true,
      validator: (rule: any, value: string, callback: Function) => {
        if (value) {
          callback();
        } else {
          callback(new Error("请选择单位"));
        }
      },
      trigger: "blur",
    },
  ],
  ...return_cash_plan,
};

const formRules = {
  employee_id: [{required: true, message: '必填', trigger: 'change'}],
  supplier_id: [{required: true, message: '必填', trigger: 'change'}],
  date: [{required: true, message: '必填', trigger: 'change'}],
}


export default defineComponent({
  name: "addItem",
  components: {editList, editLista},
  setup() {
    const setTitle: any = inject("setTitle");
    const headClass = inject("headClass");
    const Router = useRouter();
    let navindex = ref(0),
        type: any = '',
        purchase_id: any = '',
        dialog_show = ref({
          parts: false
        } as any),
        dialogNavIndex = ref(0),
        car_dialog_show = ref(false),
        dialog_data = ref([] as Array<any>),
        dialog_isload = ref(false),
        dialog_search = ref('' as string),
        serviceForm = ref({
          name: "",
          price: null,
          return_cash_plan: null,
        }),
        partsForm = ref({
          ...serviceForm.value,
          encoding: null,
          specification: "",
          unit_id: null,
        }),
        partsFormNode = ref(null),
        partsTable = ref([]),
        dialogSelect = ref({} as dialogSelect),
        serviceTable = ref([]),
        form = ref({
          purchase_type: navindex.value,
          vehicle_id: '',
          employee_id: '',
          supplier_id: '',
          purchase_desc: '',
          purchase_sh: '',
          parts: [],
          name: '',
          car_name:'',
          encoding: '',
          specification: '',
          number: '',
          unit_price: '',
          mountings_type_id: '',
          date: dateformat(new Date(), 'yyyy-MM-dd'),

        } as any),
        is_all = ref(false),
        serviceDialog = ref(false),
        supplierList = ref([] as any),
        orderDetail = ref({offer: [[], []]} as order),
        selectData: Array<project> = [],
        select = reactive({
          project_type_data: [],
          partner_data: [],
          reappearance_type_data: [],
          insurance_data: [],
          repairunit_data: [],
          car_brand_data: [],
          car_series_data: [],
          receive_data: [],
          branch_data: [],
          mountings_type_data: [],
          mountings_type_p_data: [],
          mountings_unit_data: [],
        }),
        is_load = ref(false),
        formRef = ref(null),
        PurchaseManList = ref([] as any),
        getOrderMountings = (): void => {
          getOrderCarMountings(dialogSelect.value).then((res: any) => {

            partsTable.value = res?.content?.mountings_data?.list || [];
            select.mountings_type_data = res?.content?.mountings_type || [];
            select.mountings_type_p_data = res?.content?.mountings_type_p || [];
          });
        },
        handleSelectionChange = (selection: Array<project>): void => {
          selectData = selection;
        },
        handleCurrentChange = (selection: any): void => {
          if (!is_all.value) {
            form.value.parts.push({
              mountings_type_id: selection.id,
              mountings_id: selection.id,
              name: selection.name,
              specification: selection.specification,
              mountings_type_pname: selection.mountings_type_name,
              mountings_brand_name: selection.mountings_brand_name,
              unit: selection.mountings_unit_name,
              unit_price: '0',
              number: '0'
            })
            dialog_show.value.parts = false
          }
        },
        dia_beforclose = (done:any) => {
          car_dialog_show.value=false
          done();
        },
        dialogSelectChange = (
            value: string | number,
            key: keyof dialogSelect
        ): void => {
          if (!value) {
            delete dialogSelect.value[key];
          }
          if (serviceDialog.value) {
            getOrderProject();
          } else {
            getOrderMountings();
          }
        },
        getOrderProject = (): void => {
          getOrderCarProject(dialogSelect.value).then((res: any) => {
            serviceTable.value = res?.content?.project?.list || [];
            select.project_type_data =
                res?.content?.project_type?.list || [];
          });
        },
        _onsubmit = () => {
          (formRef.value as any).validate((valid: boolean) => {
            if (!valid) return
            form.value.purchase_type = navindex.value,
                is_load.value = true
            let url = ''
            if (navindex.value == 1 || navindex.value == 2)
              url = 'adminapi/Purchase/create'
            else if (navindex.value == 3)
              url = 'adminapi/Purchase/returngoodsAll'
            else if (navindex.value == 4)
              url = 'adminapi/Purchase/returngoods'

            Request.axiosInstance({
              url: url,
              data: form.value
            }).then((res: any) => {
              is_load.value = false
              res.status == 202 && Router.go(-1)
            })

          })
        },
        _editlist_add = () => {
        if (type == 'existing'){//既用件不能选配件，自己填
            form.value.parts.push({
                mountings_type_id: '',
                mountings_id: '',
                name: '',
                specification: '',
                mountings_type_pname: '',
                mountings_brand_name: '',
                unit: '',
                unit_price: '',
                number: ''
            });
        } else {
            dialog_show.value.parts = true
        }
        
        },
        _defItem = (index: number) => {
          if (!confirm('是否确认操作？')) return
          form.value.parts.splice(index, 1)
        },
        get_dialog_data = () => {

          dialog_isload.value = true
          Request.axiosInstance({
            url: 'adminapi/OrderCar/carcodeGetList',
            data: {car_code: dialog_search.value}
          }).then((res: any) => {
            dialog_isload.value = false
            dialog_data.value = res?.content?.list || []
          })

        };

    const _table_select_carcode = (selection: any) => {
      if (!selection) return

      form.value['car_order_id'] = selection.id
      form.value['car_name'] = selection.car_code
      form.value['ordersn'] = selection.ordersn
      car_dialog_show.value = false;
    };

    watch(car_dialog_show, (newdata: any, olddata: any) => {
      get_dialog_data();
    })

    onMounted(() => {

      let title = ''
      is_load.value = true

      type = useRoute().query.type;
        purchase_id = useRoute().query.id;
      if (type == 'commonly') {
        title = "常用件采购";
        navindex.value = 1;
        if (purchase_id){
            getPurchaseInfo({purchase_id}).then((res:any)=>{
                let data = res?.content?.list;
                form.value = {
                    ...form.value,
                    supplier: data.supplier,
                    supplier_id: data.supplier_id,
                    date: new Date(data.purchase_time),
                    purchase_id: data.purchase_id,
                    employee_id: data.employee_id,
                    purchase_desc: data.purchase_desc,
                    purchase_time: data.create_time,
                    parts: data.data
                }
            });
        }
      } else if (type == 'existing') {
        title = "既用件采购";
        navindex.value = 2;
          if (purchase_id){
              getPurchaseInfo({purchase_id}).then((res:any)=>{
                  let data = res?.content?.list;
                  form.value = {
                      ...form.value,
                      supplier: data.supplier,
                      supplier_id: data.supplier_id,
                      date: new Date(data.purchase_time),
                      purchase_id: data.purchase_id,
                      employee_id: data.employee_id,
                      purchase_desc: data.purchase_desc,
                      purchase_time: data.create_time,
                      parts: data.data
                  }
              });
          }
      } else if (type == 'return') {
        title = '批量退货';
        navindex.value = 3
      } else if (type == 'returngood') {
        title = '退货';
        navindex.value = 4;
        Request.axiosInstance({
          url: 'adminapi/Purchase/info',
          data: {purchase_id: useRoute().query.id}
        }).then((res: any) => {
          var data = res?.content?.list
          for (var i = 0; i < data.data.length; i++) {
            data.data[i]['return_number_'] = data.data[i]['return_number']
            data.data[i]['return_number'] = 0
          }
          form.value = {
            ...form.value,
            supplier: data.supplier,
            supplier_id: data.supplier_id,
            date: new Date(data.purchase_time),
            purchase_id: data.purchase_id,
            employee_id: data.employee_id,
            purchase_desc: data.purchase_desc,
            purchase_time: data.create_time,
            parts: data.data
          }

        })

      }

      Request.axiosInstance({
        url: "adminapi/Purchase/adminlist"
      }).then((res: any) => {
        PurchaseManList.value = res?.content?.list || []
        Request.axiosInstance({
          url: 'adminapi/supplier/list',
            data:{status:1}
        }).then((res: any) => {
          supplierList.value = res?.content?.list || []
          is_load.value = false
        })
      })
      setTitle(["采购管理", title]);
      getOrderMountings()
    });


    return {
      navindex,
      dialog_show,
      dialogNavIndex,
      partsRules,
      partsForm,
      partsFormNode,
      partsTable,
      dialogSelect,
      serviceForm,
      select,
      headClass,
      is_all,
      handleSelectionChange,
      handleCurrentChange,
      partsColumn,
      dialogSelectChange,
      getOrderProject,
      getOrderCarProject,
      serviceDialog,
      orderDetail,
      selectData,
      serviceTable,
      form,
      PurchaseManList,
      supplierList,
      is_load,
      _onsubmit,
      formRef,
      formRules,
      _editlist_add,
      type,
      _defItem,
      car_dialog_show,
      dialog_data,
      dialog_isload,
      dialog_search,
      get_dialog_data,
      _table_select_carcode,
      dia_beforclose,
        purchase_id
  }
    ;
  },
});
